import React from "react";
import { toast } from "sonner";
import { Link2, Copy } from "lucide-react";
import { Button } from "./ui/button";

export default function ProjectLink({ token }) {
  if (!token) return null;
  const url = `${window.location.origin}/project/${token}`;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Project link copied");
    } catch {
      toast.error("Could not copy — please copy the link manually.");
    }
  };
  return (
    <section data-testid="project-link-panel" className="rounded-2xl border border-sky-200 bg-sky-50/60 p-4">
      <div className="flex items-center gap-2 font-semibold text-[#092C15]"><Link2 size={16} className="text-sky-700" /> Save Your Project Link</div>
      <p className="text-xs text-slate-600 mt-1">Return to your photos, assessment and concepts anytime — no account needed. Keep it private.</p>
      <div className="mt-2 flex gap-2">
        <input readOnly value={url} data-testid="project-link-input" className="flex-1 min-w-0 rounded-lg border border-sky-200 bg-white px-3 text-xs h-10" onFocus={(e) => e.target.select()} />
        <Button data-testid="project-link-copy" onClick={copy} className="h-10 rounded-lg bg-sky-700 hover:bg-sky-800"><Copy size={14} className="mr-1.5" /> Copy</Button>
      </div>
    </section>
  );
}
